var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React from "react";

var SvgCoolant = function SvgCoolant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 24 20",
    ref: svgRef
  }, _extends({
    width: "1em",
    height: "1em"
  }, props)), React.createElement("title", null, title), React.createElement("defs", null, React.createElement("path", {
    id: "Coolant_svg__a",
    d: "M580.772 718.936c-.936-.871-1.98-1.196-3.003-.975.19.424.298.892.298 1.386 0 .04-.003.078-.004.115.46-.104 1.016-.004 1.665.598 1.367 1.27 3.076 1.286 4.688.045 1.001-.771 1.541-.77 1.573-.769a.124.124 0 0 1-.051-.008l.318-1.503c-.257-.052-1.217-.137-2.777 1.064-1.028.792-1.888.808-2.707.047m5.218.4zm-22.671-.007s-.018.007-.054.008c.004 0 .546-.023 1.575.77 1.612 1.24 3.32 1.223 4.688-.046.7-.651 1.295-.716 1.774-.569a3.367 3.367 0 0 1 .284-1.51c-1.055-.263-2.136.056-3.102.954-.819.759-1.679.745-2.707-.047-1.56-1.202-2.52-1.116-2.777-1.064l.319 1.504m22.67.007zm.267 2.398c-.256-.055-1.217-.139-2.777 1.062-1.028.793-1.888.807-2.707.047-1.397-1.298-3.031-1.39-4.484-.251-.634.497-1.118.807-1.558.813a.811.811 0 0 0-.102.01.813.813 0 0 0-.101-.01c-.442-.006-.923-.316-1.56-.813-1.451-1.139-3.085-1.047-4.483.25-.819.76-1.679.747-2.707-.046-1.56-1.2-2.52-1.116-2.777-1.062l.319 1.502s-.017.006-.054.009c.004 0 .546-.025 1.575.768 1.612 1.241 3.32 1.223 4.688-.045 1.11-1.032 1.955-.59 2.493-.169.727.57 1.518 1.126 2.484 1.14h.011a.717.717 0 0 0 .112-.011.718.718 0 0 0 .112.011h.011c.967-.013 1.757-.57 2.484-1.14.538-.422 1.382-.863 2.493.169 1.367 1.27 3.076 1.286 4.688.045 1.028-.792 1.57-.768 1.574-.768-.035-.003-.052-.009-.052-.009l.318-1.502"
  }), React.createElement("path", {
    id: "Coolant_svg__b",
    d: "M574.67 721.617c-1.213 0-2.2-.986-2.2-2.2 0-.704.33-1.35.903-1.77l.19-.14v-11.17a1.108 1.108 0 0 1 2.213 0v1.231h2.135v.897h-2.135v2.392h2.135v.895h-2.132l-.003.463v1.93h2.135v.895h-1.631l-.04-.002h-.464v2.47l.19.139c.565.416.902 1.078.902 1.772a2.2 2.2 0 0 1-2.198 2.198"
  })), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Coolant_svg__a",
    transform: "translate(-563 -705)"
  }), React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#Coolant_svg__b",
    transform: "translate(-563 -705)"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCoolant, _extends({
    svgRef: ref
  }, props));
});
export default ForwardRef;